<template>
  <div class="animated fadeIn pt2 pb4">
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <div class="clearfix gibson px2 pt3" v-if="showMobile">
      <div class="px2 pointer mr1 relative">
        Velkommen, {{ partnerName }}
      </div>
      <!-- reminders -->
      <!-- if no reminders hide whole box, use v-if-->
      <div class="col-12 px2" v-if="reminder.length !== 0">
        <div class="flex justify-start items-start border muted-border py3 p2 mb2 shadow">
          <div class="col-12 px2">
            <p class="h4 mb0 gibson semi-bold flex justify-start items-center">
              <span class="mr2 relative" style="top:1px;">
                <svg fill="currentColor" width="24" height="24" id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><g><g><g><path d="m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"/></g></g><g><g><path d="m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"/></g></g><path d="m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"/></g></g></svg>
              </span>
              <span>Påmindelser</span>
            </p>
            <div class="flex justify-start items-start px2 py1 mt2 darkblue muted-background" v-for="item in reminder" :key="item.id">
              <a href="" class="darkblue no-hover">
                <div class="flex justify-start items-start">
                  <div class="flex-auto">
                    <!--
                      add the v-if here use the green-background   to show valid and red-background to show expired item
                    -->
                    <span class="inline-block mr1 green-background" v-if="item.pass === 0" style="height:10px;width:10px;border-radius:50%;"></span>
                    <span class="inline-block mr1 red-background" v-if="item.pass === 1" style="height:10px;width:10px;border-radius:50%;"></span>
                  </div>
                  <p class="h5 gibson line-height-2 pt1 flex justify-between items-center">
                    <span class="semi-bold m0 p0 line-height-2 block">
                     <a :href="'#/alle-moeder?mobile=' + item.mobile" > <span class="block">{{ moment(item.date_reminder).locale('da').format('LL H:mm') }}</span> </a>
                      <span class="h5 block regular mb0">{{ item.descp }}</span>
                      <span class="h6 regular mb0">{{ item.contact_name }}</span>
                    </span>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- stats -->
      <div class="col-12 px1 py2">
        <div class="border muted-border py3 p2 mb3 shadow">
          <div class="col-15 px2">
            <p class="h4 mb2 gibson semi-bold flex justify-start items-center">
              <span class="mr1 relative" style="top:1px;">
                <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502 492h-34V282c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v210h-84V20h84v173.5c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H354c-5.5 0-10 4.5-10 10v482h-26.3V138c0-5.5-4.5-10-10-10h-104c-5.5 0-10 4.5-10 10v140.2c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V148h84v344h-84V361c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v131H168V256c0-5.5-4.5-10-10-10H54c-5.5 0-10 4.5-10 10v236H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h492c5.5 0 10-4.5 10-10S507.5 492 502 492zM148 492H64V266h84V492z"/><path d="M465.1 230.6c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S466.9 232.5 465.1 230.6z"/><path d="M210.8 312.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9s-2.9 4.4-2.9 7.1 1.1 5.2 2.9 7.1c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S212.7 314.8 210.8 312.9z"/></svg>
              </span>
              <span>Statistik</span>
            </p>
            <div class="mb2">
              <p class="h5 darkblue regular line-height-golden gibson">
                Se hvordan det går med din profil.

              </p>
            </div>
            <div class="clearfix" v-if="loading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <table class="mb2">
                <tr class="darkblue h5 white-background py2" v-if="logs.TotalProfileView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{logs.TotalProfileView}}</td>
                  <td class="semi-bold py2 pr2">Profil visninger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalRatingInTimePeriod !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalRatingInTimePeriod }}</td>
                  <td class="semi-bold py2 pr2">Nye anbefalinger</td>
                </tr>

                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalPhoneView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalPhoneView }}</td>
                  <td class="semi-bold py2 pr2">Opkald til dig</td>
                </tr>

                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalHtJob !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalHtJob }}</td>
                  <td class="semi-bold py2 pr2">Opgave fra kunder</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalHtPhone !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalHtPhone }}</td>
                  <td class="semi-bold py2 pr2">Opkald fra kunder</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalCommentView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalCommentView }}</td>
                  <td class="semi-bold py2 pr2">Anbefalinger læst</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalProjectView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalProjectView }}</td>
                  <td class="semi-bold py2 pr2">Projekt visninger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalLikeanbefalinger !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalLikeanbefalinger }}</td>
                  <td class="semi-bold py2 pr2">Likes på anbefalinger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.Shared !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.Shared }}</td>
                  <td class="semi-bold py2 pr2">Profil-delinger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalFavorite !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalFavorite }}</td>
                  <td class="semi-bold py2 pr2">Kunder der har gemt din profil</td>
                </tr>
              </table>
              <p class="h5 darkblue regular line-height-golden gibson mb2">(Seneste 3 mdr.) </p>
              <a :href="url" target="_blank">
                <p class="h6 gibson semi-bold">Se din profil herdd</p>
              </a>
            </div>
            <!-- <div class="clearfix">
              <table class="table is-fullwidth is-striped">
                <thead>
                  <tr>
                    <th>Månden</th>
                    <th>Søg</th>
                    <th>Profil</th>
                    <th>Contact</th>
                    <th>Review View</th>
                    <th>Projekt View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(post, index) in logs" :key="index">
                    <td class="post-title-cell">{{months[post.Month]}}</td>
                    <td class="post-category-cell">{{post.TotalSearch}}</td>
                    <td class="post-author-cell" >{{ post.TotalProfileView }}</td>
                    <td class="post-author-cell" >{{ post.TotalHtJob }}</td>
                    <td class="post-author-cell" >{{ post.TotalCommentView }}</td>
                    <td class="post-author-cell" >{{ post.TotalProjectView }}</td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          </div>
        </div>
        <!-- <div class="lg-col-4 md-col-4 sm-col-6 xs-col-12">
          <a class="no-underline pointer test1" :href="prisenurl" target="_blank" v-if="prisenurl != ''">
            <img src="/static/img/det-perfekte-match.webp" width="100%">
          </a>
        </div> -->
        <button @click="recommend()" class="col-12 action-button p2 gibson h5 regular" v-if="nps >= 9">
          <span>Anbefal os og få et tivolikort</span>
          <span class="ml2"><i class="el-icon-right"></i></span>
        </button>
      </div>
      <div class="py2"></div>
      <!-- news -->
      <div class="col-12 px2 py2" v-if="getNews.length !== 0">
        <div class="flex justify-start items-start border muted-border pt3 pb4 p2 shadow">
          <div class="px2">
            <p class="h3 darkblue mb2 gibson semi-bold flex justify-start items-center">
              <span class="mr1 relative" style="top:1px;">
                <svg fill="currentColor" width="24" height="24"  viewBox="0 0 512.00061 512" xmlns="http://www.w3.org/2000/svg"><path d="m412 136c0 5.519531 4.480469 10 10 10s10-4.480469 10-10-4.480469-10-10-10-10 4.480469-10 10zm0 0"/><path d="m452 256c0 12.808594-1.285156 25.59375-3.816406 38-1.105469 5.410156 2.386718 10.691406 7.796875 11.796875.675781.140625 1.347656.207031 2.011719.207031 4.652343 0 8.820312-3.269531 9.789062-8.003906 2.800781-13.722656 4.21875-27.851562 4.21875-42 0-31.488281-6.828125-61.789062-20.300781-90.0625-2.375-4.984375-8.339844-7.101562-13.328125-4.726562-4.988282 2.375-7.101563 8.34375-4.726563 13.332031 12.179688 25.5625 18.355469 52.96875 18.355469 81.457031zm0 0"/><path d="m306 346h-10v-130c0-5.523438-4.476562-10-10-10h-80c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h10v80h-10c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h100c5.523438 0 10-4.476562 10-10v-40c0-5.523438-4.476562-10-10-10zm-10 40h-80v-20h10c5.523438 0 10-4.476562 10-10v-100c0-5.523438-4.476562-10-10-10h-10v-20h60v130c0 5.523438 4.480469 10 10 10h10zm0 0"/><path d="m256 186c22.054688 0 40-17.945312 40-40s-17.945312-40-40-40-40 17.945312-40 40 17.945312 40 40 40zm0-60c11.027344 0 20 8.972656 20 20s-8.972656 20-20 20-20-8.972656-20-20 8.972656-20 20-20zm0 0"/><path d="m256 0c-137.976562 0-256 117.800781-256 256 0 47.207031 13.527344 97.410156 36.335938 135.382812l-35.824219 107.457032c-1.195313 3.589844-.261719 7.554687 2.417969 10.230468 2.691406 2.691407 6.660156 3.609376 10.234374 2.414063l107.457032-35.820313c37.96875 22.8125 88.171875 36.335938 135.378906 36.335938 138.011719 0 256-117.816406 256-256 0-138.011719-117.8125-256-256-256zm0 492c-45.285156 0-93.417969-13.363281-128.757812-35.746094-2.503907-1.585937-5.625-2.003906-8.515626-1.039062l-92.914062 30.972656 30.972656-92.914062c.953125-2.851563.570313-5.976563-1.039062-8.515626-22.382813-35.335937-35.746094-83.472656-35.746094-128.757812 0-127.925781 108.074219-236 236-236s236 108.074219 236 236-108.074219 236-236 236zm0 0"/></svg>
              </span>
              <span>Nyheder</span>
            </p>
            <template>
              <div v-if="news.length !== 0">
                 <!-- eslint-disable -->
                <div :key="item.id" v-for="item in news" v-if="item.prisen === '0'" class="mt3">
                  <span class="h5 gibson semi-bold primarycolor line-height-1 mb1 block">{{ item.title }}</span>
                  <p class="gibson h6 darkblue regular mb2 flex justify-start items-center">
                    <span>
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-clock"><path d='M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z'/></svg>
                    </span>
                    <span class="ml1">{{ moment(item.timenews).locale('da').format('LL H:mm') }}</span>
                  </p>
                  <!--  <read-more more-str="Se mere" :text="item.description" link="#" less-str="Se mindre" :max-chars="200"></read-more> -->
                  <span class="h5 darkblue regular line-height-golden gibson" v-html="item.description"></span>
                </div>
                <!-- eslint-enable -->
              </div>
              <div v-else>
                <p class="h5 regular darkblue gibson line-height-4">
                  Ingen nyheder.
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- hvdkprisen -->
      <div class="col-12 px2 py2" v-if="getPrisen.length !== 0">
        <div class="flex justify-start items-start border muted-border pt3 pb4 p2 shadow">
          <div class="px2">
            <p class="h4 mb3 gibson darkblue semi-bold flex justify-start items-center">
              <span class="mr1">
                <img src="static/svg/single-house.svg" alt="" width="24" height="24">
              </span>
              <span>Håndværker Prisen 2021</span>
            </p>
            <!-- eslint-disable -->
            <div :key="item.id" v-for="item in news" v-if="item.prisen === '1'" class="mt3">
              <span class="h5 gibson semi-bold primarycolor line-height-1 mb1 block">{{ item.title }}</span>
              <p class="gibson h6 darkblue regular mb2 flex justify-start items-center">
                <span>
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-clock"><path d='M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z'/></svg>
                </span>
                <span class="ml1">{{ moment(item.timenews).locale('da').format('LL H:mm') }}</span>
              </p>
              <!-- <read-more more-str="Se mere" :text="item.description" link="#" less-str="Se mindre" :max-chars="200"></read-more> -->
              <span class="h5 darkblue regular line-height-golden gibson" v-html="item.description"></span>
            </div>
            <!-- eslint-enable -->
          </div>
        </div>
      </div>

     <!--  <div class="flex " style="padding-left:7.5em"> <a  href="https://marketing.besthand.dk/haandvaerkerpris2021"  target="_blank" rel="noopener noreferrer" ><img src="static/img/add_banner_stand.png" width="170" height="350"/></a></div>-->
    </div>
    <!-- desktop layout -->
    <div class="flex flex-wrap justify-start gibson ml4 mr3 my3" v-if="!showMobile">
      <div class="px2 pointer mr1 relative col col-12">
        Velkommen, {{ partnerName }}
      </div>
      <div class="col col-12 p2">
        <div class="col-12 muted-border border shadow p3 mb3"  v-if="reminder.length !== 0">
          <p class="h5 mb0 gibson semi-bold flex justify-start items-center">
            <span class="mr1 relative" style="top:1px;">
              <svg fill="currentColor" width="36" height="36" id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><g><g><g><path d="m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"/></g></g><g><g><path d="m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"/></g></g><path d="m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"/></g></g></svg>
            </span>
            <span>Påmindelser</span>
          </p>
          <div class="flex justify-start items-start mt2 darkblue" v-for="item in reminder" :key="item.id">
            <p class="h6 gibson line-height-2 p1 mb0 flex justify-between items-start">
              <span class="relative inline-block mr1 green-background" v-if="item.pass === 0" style="height:12px;width:12px;border-radius:50%;top:2px;"></span>
              <span class="relative inline-block mr1 red-background" v-if="item.pass === 1" style="height:12px;width:12px;border-radius:50%;top:2px;"></span>
              <span class="semi-bold m0 p0 line-height-1 block h6">
                <a class="primarycolor" :href="'#/alle-moeder?mobile=' + item.mobile">
                  <span class="block mb1">
                    {{ moment(item.date_reminder).locale('da').format('LL H:mm') }}
                  </span>
                </a>
                <span class="regular mb0">{{ item.contact_name }}</span>
                <span class="block light mb0 line-height-2" style="12px;">{{ item.descp | truncate(40, '...') }}</span>
              </span>
            </p>
          </div>
        </div>
        <div class="lg-col-4 md-col-4 sm-col-6 xs-col-12 muted-border border shadow p3 mb3">
          <div class="col-12 px0">
            <p class="h5 mb2 gibson semi-bold flex justify-start items-center">
              <span class="mr1 relative" style="top:1px;">
                <svg fill="currentColor" width="36" height="36" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502 492h-34V282c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v210h-84V20h84v173.5c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H354c-5.5 0-10 4.5-10 10v482h-26.3V138c0-5.5-4.5-10-10-10h-104c-5.5 0-10 4.5-10 10v140.2c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V148h84v344h-84V361c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v131H168V256c0-5.5-4.5-10-10-10H54c-5.5 0-10 4.5-10 10v236H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h492c5.5 0 10-4.5 10-10S507.5 492 502 492zM148 492H64V266h84V492z"/><path d="M465.1 230.6c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S466.9 232.5 465.1 230.6z"/><path d="M210.8 312.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9s-2.9 4.4-2.9 7.1 1.1 5.2 2.9 7.1c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S212.7 314.8 210.8 312.9z"/></svg>
              </span>
              <span>Statistik</span>
            </p>
            <div class="mb2">
              <p class="h6 darkblue regular line-height-2 gibson">
                Se hvordan det går med din profil.....

              </p>
            </div>
            <div class="clearfix" v-if="loading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <table class="mb2">
                <tr class="darkblue h5 white-background py2" v-if="logs.TotalProfileView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{logs.TotalProfileView}}</td>
                  <td class="semi-bold py2 pr2">Profil visninger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalRatingInTimePeriod !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalRatingInTimePeriod }}</td>
                  <td class="semi-bold py2 pr2">Nye anbefalinger</td>
                </tr>

                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalPhoneView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalPhoneView }}</td>
                  <td class="semi-bold py2 pr2">Opkald til dig</td>
                </tr>

                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalHtJob !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalHtJob }}</td>
                  <td class="semi-bold py2 pr2">Opgave fra kunder</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalHtPhone !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalHtPhone }}</td>
                  <td class="semi-bold py2 pr2">Opkald fra kunder</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalCommentView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalCommentView }}</td>
                  <td class="semi-bold py2 pr2">Anbefalinger læst</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalProjectView !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalProjectView }}</td>
                  <td class="semi-bold py2 pr2">Projekt visninger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalLikeanbefalinger !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalLikeanbefalinger }}</td>
                  <td class="semi-bold py2 pr2">Likes på anbefalinger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.Shared !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.Shared }}</td>
                  <td class="semi-bold py2 pr2">Profil-delinger</td>
                </tr>
                <tr class="darkblue h5 primarycolor white-background py2" v-if="logs.TotalFavorite !== 0">
                  <td class="semi-bold primarycolor right-align py2 pr2">{{ logs.TotalFavorite }}</td>
                  <td class="semi-bold py2 pr2">Kunder der har gemt din profil</td>
                </tr>
              </table>
              <div class="flex mediumgrey justify-start items-center white-background p1 mb2 line-height-1">
                <span class="block" style="font-size:12px">(Seneste 3 mdr.)</span>
              </div>
              <a :href="url" target="_blank" class="primarycolor">
                <p class="h6 gibson semi-bold">Se din profil her .</p>
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="lg-col-4 md-col-4 sm-col-6 xs-col-12">
          <a class="no-underline pointer test2" :href="prisenurl" target="_blank" v-if="prisenurl != ''">
            <img src="/static/img/det-perfekte-match.webp" width="100%">
          </a>
        </div> -->
        <button @click="recommend()" class="col-12 action-button p2 gibson h5 regular" v-if="nps >= 9">
          <span>Anbefal os og få et tivolikort</span>
          <span class="ml2"><i class="el-icon-right"></i></span>
        </button>
      </div>
      <div class="col col-12 p2">
        <div class="col-12 muted-border border shadow p3 self-stretch" v-if="getNews.length !== 0">
          <p class="h5 mb0 gibson semi-bold flex justify-start items-center mb2">
            <span class="mr1 relative" style="top:1px;">
              <svg fill="currentColor" width="36" height="36"  viewBox="0 0 512.00061 512" xmlns="http://www.w3.org/2000/svg"><path d="m412 136c0 5.519531 4.480469 10 10 10s10-4.480469 10-10-4.480469-10-10-10-10 4.480469-10 10zm0 0"/><path d="m452 256c0 12.808594-1.285156 25.59375-3.816406 38-1.105469 5.410156 2.386718 10.691406 7.796875 11.796875.675781.140625 1.347656.207031 2.011719.207031 4.652343 0 8.820312-3.269531 9.789062-8.003906 2.800781-13.722656 4.21875-27.851562 4.21875-42 0-31.488281-6.828125-61.789062-20.300781-90.0625-2.375-4.984375-8.339844-7.101562-13.328125-4.726562-4.988282 2.375-7.101563 8.34375-4.726563 13.332031 12.179688 25.5625 18.355469 52.96875 18.355469 81.457031zm0 0"/><path d="m306 346h-10v-130c0-5.523438-4.476562-10-10-10h-80c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h10v80h-10c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h100c5.523438 0 10-4.476562 10-10v-40c0-5.523438-4.476562-10-10-10zm-10 40h-80v-20h10c5.523438 0 10-4.476562 10-10v-100c0-5.523438-4.476562-10-10-10h-10v-20h60v130c0 5.523438 4.480469 10 10 10h10zm0 0"/><path d="m256 186c22.054688 0 40-17.945312 40-40s-17.945312-40-40-40-40 17.945312-40 40 17.945312 40 40 40zm0-60c11.027344 0 20 8.972656 20 20s-8.972656 20-20 20-20-8.972656-20-20 8.972656-20 20-20zm0 0"/><path d="m256 0c-137.976562 0-256 117.800781-256 256 0 47.207031 13.527344 97.410156 36.335938 135.382812l-35.824219 107.457032c-1.195313 3.589844-.261719 7.554687 2.417969 10.230468 2.691406 2.691407 6.660156 3.609376 10.234374 2.414063l107.457032-35.820313c37.96875 22.8125 88.171875 36.335938 135.378906 36.335938 138.011719 0 256-117.816406 256-256 0-138.011719-117.8125-256-256-256zm0 492c-45.285156 0-93.417969-13.363281-128.757812-35.746094-2.503907-1.585937-5.625-2.003906-8.515626-1.039062l-92.914062 30.972656 30.972656-92.914062c.953125-2.851563.570313-5.976563-1.039062-8.515626-22.382813-35.335937-35.746094-83.472656-35.746094-128.757812 0-127.925781 108.074219-236 236-236s236 108.074219 236 236-108.074219 236-236 236zm0 0"/></svg>
            </span>
            <span>Nyheder</span>
          </p>
          <!-- eslint-disable -->
          <div :key="item.id" v-for="item in news" v-if="item.prisen === '0'" class="mb4">
            <span class="h6 gibson semi-bold primarycolor line-height-1 mb1 block">{{ item.title }}</span>
            <p class="gibson h6 darkblue regular mb2 flex justify-start items-center">
              <span>
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-clock"><path d='M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z'/></svg>
              </span>
              <span class="regular" style="font-size:12px;">{{ moment(item.timenews).locale('da').format('LL H:mm') }}</span>
            </p>
            <read-more class="h6 line-height-2 darkblue regular gibson" more-str="Se mere" :text="item.description" link="#" less-str="Se mindre" :max-chars="251"></read-more>
            <!-- <span class="h5 darkblue regular line-height-golden gibson">   </span> -->
          </div>
           <!-- eslint-enable -->
        </div>
      </div>
    <!-- <div class="col col-3" > <a  href="https://marketing.besthand.dk/haandvaerkerpris2021"  target="_blank" rel="noopener noreferrer" ><img src="static/img/add_banner_stand.png" width="370" height="750"/></a></div>-->
      <div class="col col-12 p2">
        <div class="col-12 muted-border border shadow p3 self-stretch" v-if="getPrisen.length !== 0">
          <p class="h5 mb0 gibson semi-bold flex justify-start items-center mb2">
            <span class="mr1 relative" style="top:1px;">
              <svg fill="currentColor" width="36" height="36" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M465.7 67.4h-64.4v-56C401.3 5.1 396.2 0 389.9 0H122.1c-6.3 0-11.4 5.1-11.4 11.4v56H46.3c-6.3 0-11.4 5.1-11.4 11.4 0 52.3 31.7 99.5 79.5 119.6 12.2 52.6 53.2 94.4 105.3 107.8 2.1 26.5-15.7 51.4-42.3 57.4 -0.1 0-0.2 0.1-0.3 0.1 -0.2 0.1-0.5 0.1-0.7 0.2 -0.2 0.1-0.3 0.1-0.5 0.2 -0.2 0.1-0.4 0.1-0.6 0.2 -0.2 0.1-0.4 0.2-0.5 0.3 -0.1 0.1-0.3 0.1-0.4 0.2 -0.2 0.1-0.4 0.2-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.1-0.4 0.3-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.2-0.4 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.2 0.2-0.3 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.1 0.2-0.3 0.3-0.4 0.5 -0.1 0.1-0.2 0.3-0.3 0.4 -0.1 0.2-0.2 0.3-0.3 0.5 -0.1 0.1-0.2 0.3-0.2 0.4 -0.1 0.2-0.2 0.4-0.3 0.5 -0.1 0.2-0.1 0.3-0.2 0.5 -0.1 0.2-0.2 0.4-0.2 0.6 0 0.1-0.1 0.3-0.1 0.4 -0.1 0.2-0.1 0.5-0.2 0.7 0 0.1-0.1 0.2-0.1 0.3 -0.1 0.3-0.1 0.6-0.1 0.9 0 0.1 0 0.2 0 0.2 0 0.3 0 0.6 0 1 0 0 0 0.1 0 0.1v0.1c0 0.1 0 0.1 0 0.2v34h-32c-6.3 0-11.4 5.1-11.4 11.4v80c0 6.3 5.1 11.4 11.4 11.4h240c6.3 0 11.4-5.1 11.4-11.4v-80c0-6.3-5.1-11.4-11.4-11.4h-32v-34.3c0-3-1.2-5.8-3.1-7.8 0 0 0 0 0 0 -0.2-0.2-0.5-0.5-0.7-0.7 0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.5-0.4-0.7-0.6 -0.1 0-0.1-0.1-0.2-0.1 -0.2-0.2-0.5-0.3-0.8-0.5 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.2-0.6-0.3-0.8-0.4 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.1-0.6-0.3-0.9-0.4 0 0-0.1 0-0.1 0 -0.3-0.1-0.7-0.2-1-0.3 0 0-0.1 0-0.1 0 -26.8-6-44.5-31.1-42.3-57.7 51.6-13.7 92-55.2 104.2-107.5 47.8-20.1 79.6-67.4 79.6-119.6C477.1 72.5 472 67.4 465.7 67.4zM58.4 90.3h52.2v75.6c0 0 0 0.1 0 0.1 0 1.7 0 3.4 0.1 5.1C81.7 154.1 62 124.1 58.4 90.3zM365.1 432v57.1H148V432H365.1zM321.7 386.3v22.9H191.4v-22.9H321.7zM221.9 363.4c3.2-3.4 6.1-7.1 8.7-11.2 8.1-12.7 12.3-27.2 12.2-42 4.3 0.4 8.7 0.6 13.2 0.6 4.8 0 9.6-0.2 14.3-0.7 -0.1 20 7.7 39.1 21 53.3H221.9zM378.4 165.5c0 67.5-54.9 122.5-122.5 122.5s-122.5-54.9-122.5-122.5V22.9h245V165.5zM401.2 171.2c0.1-1.7 0.1-3.4 0.1-5.1 0 0 0-0.1 0-0.1V90.3h52.3C450 124.1 430.3 154.2 401.2 171.2z"/><path d="M292 449.1H221.1c-6.3 0-11.4 5.1-11.4 11.4S214.8 472 221.1 472h70.9c6.3 0 11.4-5.1 11.4-11.4S298.3 449.1 292 449.1z"/><path d="M325.2 125.3c-1.3-4.1-4.9-7.2-9.2-7.8l-34-4.9 -15.2-30.8c-1.9-3.9-5.9-6.4-10.2-6.4 -4.4 0-8.3 2.5-10.2 6.4l-15.2 30.8 -34 4.9c-4.3 0.6-7.9 3.6-9.2 7.8 -1.3 4.1-0.2 8.7 2.9 11.7l24.6 24 -5.8 33.8c-0.7 4.3 1 8.6 4.5 11.2 3.5 2.6 8.2 2.9 12 0.9l30.4-16 30.4 16c1.7 0.9 3.5 1.3 5.3 1.3 2.4 0 4.7-0.7 6.7-2.2 3.5-2.6 5.3-6.9 4.5-11.2l-5.8-33.8 24.6-24C325.4 134 326.5 129.4 325.2 125.3zM277.4 148.8c-2.7 2.6-3.9 6.4-3.3 10.1l2.9 16.9 -15.2-8c-1.7-0.9-3.5-1.3-5.3-1.3s-3.7 0.4-5.3 1.3l-15.2 8 2.9-16.9c0.6-3.7-0.6-7.5-3.3-10.1l-12.3-12 17-2.5c3.7-0.5 6.9-2.9 8.6-6.3l7.6-15.4 7.6 15.4c1.7 3.4 4.9 5.7 8.6 6.3l17 2.5L277.4 148.8z"/></svg>
            </span>
            <span>Håndværker Prisen 2021</span>
          </p>
          <!-- eslint-disable -->
          <div :key="item.id" v-for="item in news" v-if="item.prisen === '1'" class="mb4">
            <span class="h6 gibson semi-bold primarycolor line-height-1 mb1 block">{{ item.title }}</span>
            <p class="gibson h6 darkblue regular mb2 flex justify-start items-center">
              <span>
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-clock"><path d='M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z'/></svg>
              </span>
              <span class="ml1" style="font-size:12px;">{{ moment(item.timenews).locale('da').format('LL H:mm') }}</span>
            </p>
            <read-more class="h6 line-height-2 darkblue regular gibson" more-str="Se mere" :text="item.description" link="#" less-str="Se mindre" :max-chars="251"></read-more>
            <!-- <span class="h5 darkblue regular line-height-golden gibson">{{ item.description }}</span> -->
          </div>
          <!-- eslint-enable -->
        </div>
      </div>
    </div>
    <!-- Popup invite -->
    <b-modal ref="prisen-modal" class="prisenmodal" size="md" no-close-on-esc no-close-on-backdrop hide-footer>
      <!-- If not yet clicked -->
      <div v-if="!dialogPrisenButtonClicked" style="background-color: #003645;">
        <div class="block center p2">
          <div class="flex">
            <div class="col-12 p0">
              <h3 class="bold primarycolor line-height-2 m0">HUSK AT MELDE
                <br>DIG TIL
              </h3>
            </div>
            <div class="absolute" style="right: 1rem;">
              <a class="pointer no-hover" @click="hidePrisenModal()">
                <img src="../../../static/img/close_img.png" width="100%">
              </a>
            </div>
          </div>
          <h2 class="white bold m0" style="font-size: 3.7rem; line-height: 1.5;">DANMARKS</h2>
          <h1 class="white bold m0" style="font-size: 5rem; line-height: 0.5;">STØRSTE</h1>
          <h2 class="white bold m0" style="font-size: 2.3rem; line-height: 2.3;">HÅNDVÆRKERFEST</h2>
          <p class="white">{{prisenRegion}}</p>
        </div>
        <div class="relative flex justify-center">
          <div>
            <img src="../../../static/img/marketplace.png" width="100%">
          </div>
          <div class="absolute col-10 p0" style="top: 40%;">
            <button class="h2 bold col-12 white green-background py2 register-prisen" style="opacity: 0.9;" :disabled="disabledPrisenButton" @click="registerPrisen()">TILMELD DIG<br>GRATIS</button>
          </div>
        </div>
      </div>
      <!-- If clicked -->
      <div v-else style="background-color: #003645;">
        <div class="block center p2">
          <div class="mb3"></div>
          <h2 class="white bold mb3 line-height-1" style="font-size: 3rem;">Hvor mange <br>
          deltager?</h2>
          <el-radio-group v-model="prisenParticipant" class="col-12 p0 gibson regular" :disabled="disabledPrisenRadio" @change="submitRegister()">
            <el-radio-button label="1" class="col-6 p0 mb2">1</el-radio-button>
            <el-radio-button label="2" class="col-6 p0 mb2">2</el-radio-button>
            <el-radio-button label="3" class="col-6 p0 mb2">3</el-radio-button>
            <el-radio-button label="4" class="col-6 p0 mb2">4</el-radio-button>
            <el-radio-button label="5" class="col-6 p0 mb2">5</el-radio-button>
            <el-radio-button label="0" class="col-6 p0 mb2">Ved ikke</el-radio-button>
          </el-radio-group>
          <div class="mb4"></div>
        </div>
      </div>
    </b-modal>
    <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
  </div>
</template>
<script>
import Message from './Message'
import Simplert from 'vue2-simplert'
import updatebitrixpackagepermission from '../../components/updatebitrixpackagepermission'
export default {
  name: '',
  components: {
    Message,
    Simplert,
    updatebitrixpackagepermission
  },
  data () {
    return {
      news: [],
      logs: [],
      // prisenurl: 'https://www.haandvaerker.dk/haandvaerker-prisen-2022',
      prisenurl: '',
      months: [],
      otherNews: [],
      reminder: [],
      showDismissibleAlert: false,
      starMessage: '',
      partnerName: '',
      url: '',
      showHaandvearker: false,
      showImentor: false,
      messages: [],
      loading: true,
      nps: '',
      prisenRegion: '',
      dialogPrisenVisible: true,
      dialogPrisenButtonClicked: false,
      disabledPrisenButton: false,
      prisenParticipant: '',
      disabledPrisenRadio: false,
      partnerzipcode: ''
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.getBadges()
    this.Reload()
    this.getPartnerZip()
    this.partnerName = localStorage.getItem('name')

    // Redirect to marketplace when clicked
    setTimeout(() => {
      var maketplace = document.querySelector('#dropMarkedsplads')
      maketplace.addEventListener('click', function () {
        window.location.replace('#/markedsplads')
      })
    }, 500)

    // Redirect to webshop categories when clicked
    setTimeout(() => {
      var webshopMenu = document.querySelector('#dropWebshop')
      webshopMenu.addEventListener('click', function () {
        window.location.replace('#/webshop/overview')
      })
    }, 500)
    // Hide Customer project, Messages, Mine kunder test if not test users
    if (this.$bitrixapi !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
      setTimeout(() => {
        if (document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard') !== null) {
          document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard').classList.add('hide')
        }
        // if (document.querySelector('ul.nav-dropdown-items li#customer-projects\\/approved-projects') !== null) {
        //   document.querySelector('ul.nav-dropdown-items li#customer-projects\\/approved-projects').classList.add('hide')
        // }
        // if (document.getElementById('dropBeskeder') !== null) {
        //   document.getElementById('dropBeskeder').classList.add('hide')
        // }
        // if (document.getElementById('dropMine kunder Test') !== null) {
        //   document.getElementById('dropMine kunder Test').classList.add('hide')
        // }
      }, 300)
    }
    if (this.$bitrixapi !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
      setTimeout(() => {
        document.getElementById('anbefalinger-sammendrag').classList.add('hide')
      }, 300)
    }
    // Hide webshop if not isshop
    if (localStorage.getItem('isshop') === 'false') {
      setTimeout(() => {
        document.getElementById('dropWebshop').classList.add('hide')
      }, 300)
    }
    // Hide opgaveinvitationer
    var opgaveInvitationer = document.getElementById('opgaveinvitationer')
    if (opgaveInvitationer) {
      if (localStorage.getItem('isjobInvited') === 'false' || localStorage.getItem('showAddendum') !== 'true') {
        setTimeout(() => {
          opgaveInvitationer.classList.add('hide')
        }, 300)
      }
    }
    // Hide udbud if not in bitrixpackage
    if (localStorage.getItem('PartnerLoginUdbudJobs') === 'false') {
      setTimeout(() => {
        document.getElementById('offentlige-udbud').classList.add('hide')
      }, 300)
      // setTimeout(() => {
      //   document.getElementById('privat-udbud').classList.add('hide')
      // }, 500)
    }
    //  Addendum
    var Addendum = document.querySelector('#dropArbejdsseddel')
    if (Addendum) {
      if (localStorage.getItem('showAddendum') === 'true') {
        Addendum.classList.remove('hide')
      } else {
        Addendum.classList.add('hide')
      }
    }
  },
  computed: {
    getNews () {
      return this.news.filter(value => value.prisen === '0')
    },
    getPrisen () {
      return this.news.filter(value => value.prisen === '1')
    }
  },
  mounted () {
    this.checkBadges()
  },
  methods: {
    hideshop () {
      document.getElementById('dropWebshop').classList.add('hide')
    },
    checkBadges () {
      //  Digital package
      if (localStorage.getItem('showbadgewebshop') === 'yes') {
        document.querySelector('a[href="#/badges"]').classList.remove('hide')
      } else {
        document.querySelector('a[href="#/badges"]').classList.add('hide')
      }
    },
    getBadges () {
      /* eslint-disable no-unused-vars */
      var data = {
        operation: 'oversigt_getsupplierprofilebyid',
        levid: this.haaId,
        salesPerson: this.salesPerson
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          var badgesList = res.Badges
          localStorage.setItem('zipcode', res.Profile.Zipcode)
          this.partnerzipcode = res.Profile.Zipcode
          // this.checkPrisen()
          var filteredBadges = badgesList.filter(function (property) {
            return property['Industry'] !== null
          })
          if (filteredBadges.length === 0) {
            localStorage.setItem('showbadgewebshop', 'no')
            this.hideshop()
          } else {
            localStorage.setItem('showbadgewebshop', 'yes')
          }
        },
        (err) => {
          console.log('Error in getBadgesCount()', err)
        }
      )
    },
    Reload () {
      if (localStorage.getItem('haaid') !== '0') {
        this.showHaandvearker = true
      }
      if (localStorage.getItem('imentor') !== '0') {
        this.showImentor = true
      }
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'newsFeed', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, {emulateJSON: true})
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.loading = false
            this.messages = res.resultMessage
            if (res.resultMessage.length === 0) this.showDismissibleAlert = true
            this.news = res.resultNews
            this.reminder = res.reminder
            this.logs = res.logs
            this.months = res.months
            this.otherNews = res.otherNews
            // this.url = res.url
            this.url = 'https://www.haandvaerker.dk/profil/firma/x/' + this.haaId
            this.nps = parseInt(res.nps)
          },
          response => {
            alert('error')
          }
        )
      this.cid = this.$route.query.id
    },
    showMeetingReminder (item) {
      this.$router.push('/inbox?email=' + item.id)
    },
    showItemDetails (email) {
      this.$router.push('/inbox?email=' + email.id)
    },
    recommend () {
      this.$router.push('/recommend')
    },
    getPartnerZip () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            localStorage.setItem('CompanyZip', res.Postnr)
            localStorage.setItem('PartnerTelefon', res.Telefon)
            localStorage.setItem('Cvrnr', res.Cvrnr)
          },
          response => {
            alert('error')
          }
        )
    },
    showPrisenModal () {
      this.$refs['prisen-modal'].show()
    },
    hidePrisenModal () {
      this.$refs['prisen-modal'].hide()
    },
    checkPrisen () {
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/find/region?zipCode=' + this.partnerzipcode, { emulateJSON: true }).then(
        response => {
          var res = response.body
          // if (res.region === 'Region Hovedstaden') {
          //   this.prisenurl = 'https://www.haandvaerker.dk/haandvaerker-prisen-2022-slut-resultater-region-hovedstaden'
          // } else if (res.region === 'Region Nordsjælland') {
          //   this.prisenurl = 'https://www.haandvaerker.dk/haandvaerker-prisen-2022-slut-resultater-region-nordsj%C3%A6lland'
          // } else if (res.region === 'Region Sjælland') {
          //   this.prisenurl = 'https://www.haandvaerker.dk/haandvaerker-prisen-2022-slut-resultater-region-sj%C3%A6lland'
          // } else if (res.region === 'Region Syddanmark') {
          //   this.prisenurl = 'https://www.haandvaerker.dk/haandvaerker-prisen-2022-slut-resultater-region-syddanmark'
          // } else if (res.region === 'Region Midtjylland') {
          //   this.prisenurl = 'https://www.haandvaerker.dk/haandvaerker-prisen-2022-slut-resultater-region-midtjylland'
          // } else if (res.region === 'Region Nordjylland') {
          //   this.prisenurl = 'https://www.haandvaerker.dk/haandvaerker-prisen-2022-slut-resultater-region-nordjylland'
          // } else {
          // }
          this.prisenurl = res.data.PRISEN_URL
          this.prisenRegion = res.data.PRISE_REGION
          // this.showPrisenModal()
        },
        response => {
          console.log('Error in checkPrisen()', response)
        }
      )
    },
    registerPrisen () {
      this.disabledPrisenButton = true
      var data = {
        operation: 'register_prisen',
        salesPerson: this.salesPerson,
        type: 'POST'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.dialogPrisenButtonClicked = true
            this.disabledPrisenButton = false
          }
        },
        response => {
          console.log('Error in registerPrisen()', response)
        }
      )
    },
    submitRegister () {
      this.disabledPrisenRadio = true
      var data = {
        operation: 'total_prisen',
        total: this.prisenParticipant,
        salesPerson: this.salesPerson,
        type: 'POST'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.hidePrisenModal()
            this.disabledPrisenRadio = false
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          }
        },
        response => {
          console.log('Error in submitRegister()', response)
        }
      )
    }
  }
}
</script>
<style>
#readmore {
  color: rgb(25, 163, 192);
  font-weight: 600;
}
.modal-header {
  padding-bottom:0;
}
.modal-footer,
.modal-header {
  border-bottom:0;
  border-top:0;
}
.tab-content {
  border:0;
  padding:0;
}
.tab-content .tab-pane {
  padding-top:0;
}
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
}
.creditcheck-container > .card-body {
  padding: 0!important;
}
.pull-right {
  display: inline-block;
  margin-left: 1%;
}
.checkbox {
  margin-left: 1.5em;
  margin-right: 2em;
}
.star {
  margin-right: 2em;
}
.message {
  margin-left: 0px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-bottom: 16px;
  cursor: pointer;
  border-bottom: 2px solid #efefef;
}
.row {
  margin-right: -15px;
}
.message a {
  color: black;

}
.message+.message {
  border-top: 1px solid #efefef;
}
.message.read {
  background: #efefef;
}
.message.unread {
  font-weight: bold;
}
.message.selected {
  background: #ffffcc;
}
.message:hover {
  margin-left: -3px!important;
  border-left: 3px solid #ccc!important;
}
.message-body {
  background: #ccc;
  margin-left: 0;
  margin-bottom: 1em;
  padding-top: 1em;
  padding-bottom: 1em;
}
.toolbar .label-select {
  width: auto;
  display: inline;
}
.toolbar select,
.toolbar button,
.toolbar a,
.toolbar .badge {
  margin-right: .5em;
  margin-bottom: .5em;
}
footer.spacer {
  margin-bottom: 20em;
}
.label {
  margin-right: .5em;
}
.fa-close {
  cursor: pointer;
}
.form-horizontal {
  margin-left: 1em;
}
.modal-content .modal-body {
  padding: 0;
}
.el-radio-button__inner {
  white-space: normal;
  width: 100%;
  padding: 4rem;
  font-size: 2rem;
  font-weight: 600;
  color: #003645;
  border: 8px solid #003645 !important;
}
.el-radio-button:last-child .el-radio-button__inner {
  padding: 3rem;
}
.el-radio-button__inner:hover {
  color: #003645;
}
.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: #4dcf55;
  box-shadow: none;
}
button.register-prisen:disabled {
  color: red;
  background-color: gray;
  border-color: gray;
  cursor: not-allowed;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// Newsfeed.vue?2197e9d0